export const environment = {
  production: false,
  configFile: 'assets/config/config.qa.json'
};
